import { defineStore } from "pinia";
import {
  TopolCustomBlockData,
  TopolCustomBlocksDataSchema,
} from "@/schemas/contentBlock/contentBlockScheme";
import { useNotificationsStore } from "./notifications";

interface State {
  customBlocks: TopolCustomBlockData[];
}

export const useCustomBlocksStore = defineStore("customBlocks", {
  state: (): State => ({
    customBlocks: [],
  }),
  actions: {
    setCustomBlocks(customBlocks: TopolCustomBlockData[]) {
      const { error, data, success } =
        TopolCustomBlocksDataSchema.safeParse(customBlocks);
      if (!success) {
        console.error("Error loading custom blocks", error.issues);
        const notificationsStore = useNotificationsStore();
        notificationsStore.createNotification({
          text: "Error loading custom blocks",
          type: "error",
        });
        return;
      }
      this.customBlocks = data;
    },
  },
});
